import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { AccountIntakeModal } from '../intake/AccountIntakeModal'
import { useAccountTypeCatalog } from '../hooks/useAccountTypeCatalog'
import { useResolvedConnector } from '../hooks/useResolvedConnector'
import { createEmptyAccount } from '../domain/types'

interface ContactAccountIntakeProps {
  contactId: string
  contactName: string
  onCancel: () => void
}

export const ContactAccountIntake: FC<ContactAccountIntakeProps> = ({ contactId, contactName, onCancel }) => {
  const accountId = useAppSelector(selectAccountId)
  const navigate = useNavigate()

  const { connectors, connector, setConnector } = useResolvedConnector()
  const catalog = useAccountTypeCatalog(accountId, connector ?? '')

  return (
    <AccountIntakeModal
      show
      connectors={connectors}
      connector={connector}
      onConnectorChange={setConnector}
      catalog={catalog}
      initialAccounts={[createEmptyAccount()]}
      contactOptions={[{ id: contactId, name: contactName }]}
      defaultHolderName={contactName}
      defaultHolderContactId={contactId}
      onCancel={onCancel}
      onContinue={(intakeAccounts) =>
        navigate(`/workspace/account-opening?${new URLSearchParams({ contactId })}`, {
          state: { intakeAccounts, intakeConnector: connector },
        })
      }
    />
  )
}
